import { IonFooter, IonLabel, IonToolbar } from "@ionic/react";
import { QueryResult, maxResults } from "../hooks/useQueryExec";
import React from "react";

const SearchFooter: React.FC<{
  totalRows: number;
  filterRows: QueryResult[];
  children?: React.ReactNode;
}> = (props) => {
  const { totalRows, filterRows, children } = props;
  return (
    <IonFooter translucent={true} hidden={totalRows === 0}>
      <IonToolbar>
        <IonLabel style={{ paddingLeft: 8 }}>
          Displaying {Math.min(filterRows.length, maxResults)} of {totalRows}
        </IonLabel>
      </IonToolbar>
      {children}
    </IonFooter>
  );
};

export default SearchFooter;
